export const GET_PROJECT_LIST = 'PROJECT/GET_PROJECT_LIST';
export const GET_PROJECT_LIST_SUCCESS = 'PROJECT/GET_PROJECT_LIST_SUCCESS';

export const GET_TASK_LIST = 'PROJECT/GET_TASK_LIST';
export const GET_TASK_LIST_SUCCESS = 'PROJECT/GET_TASK_LIST_SUCCESS';

export const GET_ERROR = 'PROJECT/GET_ERROR';
